import { InnerQueryExpression } from "../InnerQueryExpression";

export class MaxCallExpression implements InnerQueryExpression {
    public readonly $discriminator = "MaxCall";
    public readonly argument?: InnerQueryExpression;

    public constructor(argument?: InnerQueryExpression) {
        this.argument = argument;
    }
}
